import { render, staticRenderFns } from "./shopRank2.vue?vue&type=template&id=5588f52e&scoped=true"
import script from "./shopRank2.vue?vue&type=script&lang=js"
export * from "./shopRank2.vue?vue&type=script&lang=js"
import style0 from "./shopRank2.vue?vue&type=style&index=0&id=5588f52e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588f52e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5588f52e')) {
      api.createRecord('5588f52e', component.options)
    } else {
      api.reload('5588f52e', component.options)
    }
    module.hot.accept("./shopRank2.vue?vue&type=template&id=5588f52e&scoped=true", function () {
      api.rerender('5588f52e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/shopRank2.vue"
export default component.exports